// @vue/component
export default {
  name: 'FaqCategories',

  props: {
    faqCategories: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      selectedCategorie: 'all',
    };
  },

  computed: {
    isLoading() {
      return this.$store.getters['app/pendingStoreActions'].includes([
        'settings/getFaq',
      ]);
    },
  },

  methods: {
    handleSelectCategorie(categorie) {
      this.selectedCategorie = categorie;
      this.$EventBus.$emit('FaqCategories/SELECT_CATEGORY', categorie);
    },
  },
};
